import classNames from 'classnames';
import React, { useEffect } from 'react';
import '../../styles/Spinner.scss'; // Import css modules stylesheet as styles
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { Logo } from '../Icons';

export interface Props {
  color?: string;
  text?: string;
  headerText?: string;
  style?: any;
  relative?: boolean;
  inText?: boolean;
  button?: boolean;
  loadMore?: boolean;
  fullScreen?: boolean;
}

export const SpinnerV2 = (props: Props) => {
  useEffect(() => {
    props.fullScreen && document.documentElement.classList.add('scrollHidden');
    console.log(Logo);
    // returned function will be called on component unmount
    return () => {
      document.documentElement.classList.remove('scrollHidden');
    };
  }, []);

  return props.relative ? (
    <SwitchTransition mode='out-in'>
      <CSSTransition
        in={true}
        timeout={{
          enter: 500,
          exit: 500,
        }}
        classNames='my-node'
      >
        <div
          style={props.style}
          className={classNames('loading', 'inText', {
            relative: props.relative,
          })}
        >
          <div className={'wrapper'}>
            <div className={classNames('loader')}>
              <svg version='1.1' id='loader-1' x='0px' y='0px' viewBox='0 0 50 50'>
                <path d='M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z'>
                  <animateTransform
                    attributeType='xml'
                    attributeName='transform'
                    type='rotate'
                    from='0 25 25'
                    to='360 25 25'
                    dur='0.8s'
                    repeatCount='indefinite'
                  />
                </path>
              </svg>
            </div>
            <div className={'logo'}>
              <Logo />
            </div>
            <p className={'semiText'}>{props.headerText}</p>
            <p className={'smallText'}>{props.text}</p>
          </div>
        </div>
      </CSSTransition>
    </SwitchTransition>
  ) : (
    <SwitchTransition mode='in-out'>
      <CSSTransition in={true} timeout={500} classNames='my-node'>
        <div
          style={props.style}
          className={classNames('loading', {
            ['relative']: props.relative,
          })}
        >
          <div className={'wrapper'}>
            <div className={'loader'}>
              <svg version='1.1' id='loader-1' x='0px' y='0px' viewBox='0 0 50 50'>
                <path d='M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z'>
                  <animateTransform
                    attributeType='xml'
                    attributeName='transform'
                    type='rotate'
                    from='0 25 25'
                    to='360 25 25'
                    dur='0.8s'
                    repeatCount='indefinite'
                  />
                </path>
              </svg>
            </div>
            <div className={'logo'}>
              <Logo />
            </div>
            <p className={'semiText'}>{props.headerText}</p>
            <p className={'smallText'}>{props.text}</p>
          </div>
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
};
